import { SimilarCustomer } from 'app/model/shared/user/user';
import {BaseResponse} from './internal/baseresponse';


export class UserValidateMobile {
  name: string;
  birthday: string;
  tel_com_cd: string;
  nation: string;
  sex: string;
  tel_no: string;
  auth_code: string;
}


export class UserVerifyMobile {
  cert_no: string;
}

export class UserVerifiyMobile {
  name: string;
  birthday: string;
  tel_com_cd: string;
  nation: string;
  sex: string;
  tel_no: string;
  auth_code: string;
}


export class UserValidateMobileResult extends BaseResponse {
  data: string;
}

export class UserVerifyMobileResult extends BaseResponse {
  data: string;
}


/**
 * 동일 신분증 번호를 이미 보유한 다른 고객. 서버가 CM010/CM038 응답의 data 로 내려준다.
 * 내부 PK 는 내려오지 않고 고객번호만 담긴다.
 */
export class CoiConflict {
  customer_id: string;
}

export class UserModifyResult extends BaseResponse {
  data: Array<CoiConflict>;

  /**
   * 신분증 중복 오류 메시지에 충돌한 고객번호를 덧붙인 사본을 만든다.
   * 충돌 정보가 없으면(중복 외 오류) 원본을 그대로 반환한다.
   */
  withCoiConflictDetail(): UserModifyResult {
    if (!this.data || !this.data.length) {
      return this;
    }

    const owners = this.data
      .map((conflict) => conflict.customer_id)
      .filter((customerId) => !!customerId)
      .join(', ');

    if (!owners) {
      return this;
    }

    return Object.assign(new UserModifyResult(), this, {
      message: this.message + ' Already registered to: ' + owners,
    });
  }
}

export class CustomerUpdateValidResult extends BaseResponse {
  data: CustomerUpdateValidResultData;
}
export class CustomerUpdateValidResultData {
  problemList: Array<SimilarCustomer>;
  canContinuable: boolean;
}


// WEBPACK FOOTER //
// ./src/app/response/usermodifyresult.ts